import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { MessageCircle, MessagesSquare, FileText, Send, Plug, BarChart3 } from 'lucide-react';
import WhatsAppConversations from './WhatsAppConversations';
import WhatsAppOutbox from './WhatsAppOutbox';
import { WhatsAppTemplatesPanel } from '../components/WhatsAppTemplatesPanel';
import { WhatsAppConnectionPanel } from '../components/WhatsAppConnectionPanel';
import { WhatsAppAnalyticsPanel } from '../components/WhatsAppAnalyticsPanel';

const VALID_TABS = ['conversations', 'templates', 'queue', 'analytics', 'connection'];

export default function WhatsAppWorkspace() {
  const params = new URLSearchParams(window.location.search);
  const initial = VALID_TABS.includes(params.get('tab')) ? params.get('tab') : 'conversations';
  const [tab, setTab] = useState(initial);

  const onTab = (v) => {
    setTab(v);
    const p = new URLSearchParams(window.location.search);
    p.set('tab', v);
    if (v !== 'conversations') p.delete('lead');
    window.history.replaceState(null, '', `${window.location.pathname}?${p.toString()}`);
  };

  return (
    <div className="space-y-5" data-testid="whatsapp-workspace-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <MessageCircle className="h-6 w-6 text-emerald-500" />WhatsApp
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          One workspace for conversations, templates, outbound queue & connection
        </p>
      </div>

      <Tabs value={tab} onValueChange={onTab}>
        <TabsList className="grid w-full grid-cols-3 sm:w-auto sm:inline-flex" data-testid="wa-workspace-tabs">
          <TabsTrigger value="conversations" className="gap-1.5" data-testid="wa-tab-conversations">
            <MessagesSquare className="h-4 w-4" />Conversations
          </TabsTrigger>
          <TabsTrigger value="templates" className="gap-1.5" data-testid="wa-tab-templates">
            <FileText className="h-4 w-4" />Templates
          </TabsTrigger>
          <TabsTrigger value="queue" className="gap-1.5" data-testid="wa-tab-queue">
            <Send className="h-4 w-4" />Queue
          </TabsTrigger>
          <TabsTrigger value="analytics" className="gap-1.5" data-testid="wa-tab-analytics">
            <BarChart3 className="h-4 w-4" />Analytics
          </TabsTrigger>
          <TabsTrigger value="connection" className="gap-1.5" data-testid="wa-tab-connection">
            <Plug className="h-4 w-4" />Connection
          </TabsTrigger>
        </TabsList>

        <TabsContent value="conversations" className="mt-4">
          <WhatsAppConversations embedded />
        </TabsContent>
        <TabsContent value="templates" className="mt-4">
          <WhatsAppTemplatesPanel />
        </TabsContent>
        <TabsContent value="queue" className="mt-4">
          <WhatsAppOutbox embedded />
        </TabsContent>
        <TabsContent value="analytics" className="mt-4">
          <WhatsAppAnalyticsPanel />
        </TabsContent>
        <TabsContent value="connection" className="mt-4">
          <WhatsAppConnectionPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
